export const ZERO_WIDTH_SPACE = '\u200b';